export default __webpack_public_path__ + "static/media/google-play.837ace5f.svg";